import { StackdriverErrorReporting } from "@gt/gt-frontend/build/services/gcloud/StackdriverErrorReporting/StackdriverErrorReporting";

export const VibescoutSpecialErrorReporter = StackdriverErrorReporting.setup({
  consoleOnly: process.env.NODE_ENV === "development",
  serviceId: "vibescout-special-web-client",
  serviceVersion: "1",
  projectId: "vibescoutapp",
  apiKey: "AIzaSyAJoZXA1te4HE_OuzbHZs8rNQU3QRmpyWE",
});
